import { useLocation } from "react-router-dom";
import { useAuth } from "@context/AuthContext";
import { getRoutePermission, isAllowedByRule } from "@routes/permissions";

/**
 * Centralized role gate for private routes. Wrap this INSIDE AuthWrapper
 * (so `user` is guaranteed to exist by the time this runs).
 *
 * Looks up the current path in routes/permissions.js and evaluates its
 * rule (null = open, array = role membership, function = custom check
 * such as role + firm_type combined) against the logged-in user.
 *
 * This does NOT replace any role-based conditional rendering already
 * inside individual pages (e.g. CandidateProfilePage showing/hiding tabs
 * per role) - that's a different, finer-grained concern. This only
 * decides whether the page renders AT ALL.
 */
export default function RoleGuard({ children }) {
  const { user } = useAuth();
  const location = useLocation();
  const rule = getRoutePermission(location.pathname);

  if (!isAllowedByRule(rule, user)) {
    return (
      <div style={{ background:"#fff", border:"1px solid #E5E7EB", borderRadius:14, padding:"48px 24px", textAlign:"center", margin:20 }}>
        <i className="fa-solid fa-lock" style={{ fontSize:28, color:"#D1D5DB", display:"block", marginBottom:12 }} />
        <div style={{ fontSize:15, fontWeight:700, color:"#111827" }}>Access Denied</div>
        <div style={{ fontSize:13, color:"#6B7280", marginTop:4 }}>You don't have permission to view this page.</div>
      </div>
    );
  }

  return children;
}
